@if (formGroup$ | async; as formGroup) {
  <form [formGroup]="formGroup">
    <div class="container">
      <div class="row">
        <div class="col">
          <pas-input
            [formControl]="$any(formGroup.get('supplierNumber'))"
            formControlName="supplierNumber"
            subLabel="{{ 'partsAgreement.supplierNumber' | translate }}"></pas-input>
        </div>
        <div class="col">
          <pas-input
            [formControl]="$any(formGroup.get('supplierName'))"
            formControlName="supplierName"
            subLabel="{{ 'partsAgreement.supplierName' | translate }}"></pas-input>
        </div>
        <div class="col">
          <pas-input
            [formControl]="$any(formGroup.get('sparePartNumber'))"
            formControlName="sparePartNumber"
            subLabel="{{ 'partsAgreement.sparePartNumber' | translate }}"></pas-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <pas-input
            [formControl]="$any(formGroup.get('technicalFactor'))"
            formControlName="technicalFactor"
            subLabel="{{ 'partsAgreement.technicalFactor' | translate }}"></pas-input>
        </div>
        <div class="col">
          <pas-input
            [formControl]="$any(formGroup.get('orderType'))"
            formControlName="orderType"
            subLabel="{{ 'partsAgreement.orderType' | translate }}"></pas-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <pas-datetime-picker
            [formControl]="$any(formGroup.get('productionDateFrom'))"
            locale="de"
            subLabel="{{ 'partsAgreement.productionDateFrom' | translate }}"
            formControlName="productionDateFrom"
            pickerType="date"></pas-datetime-picker>
        </div>
        <div class="col">
          <pas-datetime-picker
            [formControl]="$any(formGroup.get('productionDateTo'))"
            locale="de"
            subLabel="{{ 'partsAgreement.productionDateTo' | translate }}"
            formControlName="productionDateTo"
            pickerType="date"></pas-datetime-picker>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <pas-input
            [formControl]="$any(formGroup.get('modelYearFrom'))"
            formControlName="modelYearFrom"
            subLabel="{{ 'partsAgreement.modelYearFrom' | translate }}"></pas-input>
        </div>
        <div class="col">
          <pas-input
            [formControl]="$any(formGroup.get('modelYearTo'))"
            formControlName="modelYearTo"
            subLabel="{{ 'partsAgreement.modelYearTo' | translate }}"></pas-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <pas-datetime-picker
            [formControl]="$any(formGroup.get('validityDateFrom'))"
            locale="de"
            subLabel="{{ 'partsAgreement.validityDateFrom' | translate }}"
            formControlName="validityDateFrom"
            pickerType="date"></pas-datetime-picker>
        </div>
        <div class="col">
          <pas-datetime-picker
            [formControl]="$any(formGroup.get('validityDateTo'))"
            [minDate]="validityDateToMinDate$ | async"
            [maxDate]="longTimeAhead"
            locale="de"
            subLabel="{{ 'partsAgreement.validityDateTo' | translate }}"
            formControlName="validityDateTo"
            pickerType="date"></pas-datetime-picker>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <pas-textarea
            [formControl]="$any(formGroup.get('comment'))"
            [cols]="3"
            [maxLength]="280"
            formControlName="comment"
            subLabel="{{ 'partsAgreement.comment' | translate }}"></pas-textarea>
          @if (formGroup.controls['comment'].invalid) {
            <span class="errorSpan">
              @if (formGroup.controls['comment'].errors.invalidCommentCharacters) {
                <div class="errorDiv">
                  {{ 'partsAgreement.commentInvalidCharacters' | translate }}
                </div>
              }
            </span>
          }
        </div>
      </div>
    </div>
  </form>
}
